import styled, { css } from 'styled-components'
import Flex from 'components/priority/Flex/Flex'
import colors from 'utils/styling/colors'

type TabProps = {
  selected?: boolean
}

export const Tab = styled(Flex)<TabProps>(
  ({ selected }) => css`
    background-color: ${selected && colors('paleSecondary')};
    &:hover {
      background-color: ${colors('paleSecondary')};
    }
  `,
)
